
<div class="alert alert-info" role="region" aria-label="Page Instructions" *ngIf="hasInstructions()">
	<span [innerHTML]="getInstructions()"></span>
</div>

<div>
	<div *ngIf="!themes">
		Loading...
	</div>

	<empty-state *ngIf="!!themes && themes.length == 0"
	imgSrc="/assets/empty/theme.png"
	title="You don&apos;t have any themes yet"
	description="A Theme is a way to organize your Projects and Activities on your Dossier.">
		<button class="btn btn-primary btn-sm"
			(click)="newTheme()">
			+ Add Theme
		</button>
	</empty-state>

	<div *ngIf="!!themes && themes.length > 0">
		<div role="region" aria-label="Themes Header">
      <h1 class="screen-reader-only">Themes</h1>
			<span class="h5" style="margin-bottom: 0;">Themes</span>
			<button class="btn btn-primary btn-sm" style="margin-left:1em;" (click)="newTheme()">
				+ Add Theme
			</button>
		</div>
		<br>
		<div class="row">
			<div class="col-md-12 mb-3" *ngFor="let t of themes">
				<div class="card project-card" nohotkey>
					<div class="card-header">
						<div class="font-weight-semi-bold">
							<inline-editor 
								[edited]="themeNames[t.id] != t.name" 
								[saveFn]="saveThemeName(t, themeNames[t.id])"
								[editStartFn]="confirmEditStart()"
								(transitionToEdit)="nameInput.focus(); nameInput.select();" 
								(cancel)="themeNames[t.id] = t.name"
								#nameEditor>
								<div role="region" aria-label="Theme Name" readonly>
									{{t.name}}
									<em [hidden]="!!t.name">
										Click or Tap to edit
									</em>
								</div>
								<div editor>
									<input 
										type="text" 
										[(ngModel)]="themeNames[t.id]" 
										#nameInput 
										class="form-control" 
										[disabled]="nameEditor.saving">
									<div [matTooltip]="StaticText.ThemeNameToolTip">
										<i class="fa fa-fw fa-info-circle"></i>
									</div>
								</div>
							</inline-editor>
						</div>
						<div class="text-muted text-xs mt-2" role="region" aria-label="Theme Last Edited">
							<span>
								Last Edited:
								<span [ngSwitch]="!!t.lastUpdated">
									<span *ngSwitchCase="true" class="font-weight-semi-bold">{{t.lastUpdated | date}}</span>
									<span *ngSwitchCase="false">N/A</span>
								</span>
							</span>
							<button (click)="archive(t)" 
								class="btn btn-link btn-sm text-danger float-right" 
								[title]="StaticText.ArchiveTheme"
								*ngIf="canArchive(t)">
								<i class="fa fa-fw fa-archive"></i>
								Archive (Delete)
							</button>
						</div>
					</div>
					<div class="card-body">
						<div class="card-text">
							<div class="mb-3">
								<div class="project-label" [matTooltip]="StaticText.ThemeBackgroundToolTip" role="region" aria-label="Theme Background, Clientele, Goals, Inputs">
									Background, Clientele, Goals, Inputs
									<i class="fa fa-fw fa-info-circle"></i>
								</div>
								<div class="mt-1 text-sm">
									<inline-editor 
										[edited]="themeSituations[t.id] != t.situation" 
										[saveFn]="saveThemeSituation(t, themeSituations[t.id])" 
										(cancel)="themeSituations[t.id] = t.situation"
										#situationEditor>
										<div role="region" aria-label="Theme Situation" readonly>
											<div [innerHtml]="t.situation"></div>
											<em [hidden]="!!t.situation">
												Click or Tap to edit
											</em>
										</div>
										<div editor *ngIf="situationEditor.state === 'editing'">
											<textboxio 
												[(content)]="themeSituations[t.id]"
												#situationInput></textboxio>
										</div>
									</inline-editor>
								</div>
							</div>
							<div class="mb-3">
								<div class="project-label" [matTooltip]="StaticText.ThemeMethodsToolTip" role="region" aria-label="Theme Methods, Outcomes, Impacts">
									Methods, Outcomes, Impacts
									<i class="fa fa-fw fa-info-circle"></i>
								</div>
								<div class="mt-1 text-sm">
									<inline-editor 
										[edited]="themeNarratives[t.id] != t.narrative" 
										[saveFn]="saveThemeNarrative(t, themeNarratives[t.id])" 
										(cancel)="themeNarratives[t.id] = t.narrative"
										#narrativeEditor>
										<div role="region" aria-label="Theme Narrative" readonly>
											<div [innerHtml]="t.narrative"></div>
											<em [hidden]="!!t.narrative">
												Click or Tap to edit
											</em>
										</div>
										<div editor *ngIf="narrativeEditor.state === 'editing'">
											<textboxio 
												[(content)]="themeNarratives[t.id]" 
												#narrativeInput></textboxio>
										</div>
									</inline-editor>
									<div role="region" aria-label="UC Delivers Story Link">
										<uc-delivers-story-link></uc-delivers-story-link>
									</div>
								</div>
							</div>
							<div class="mb-3" role="region" aria-label="Theme Outcome Tags">
								<div class="project-label" [matTooltip]="StaticText.ThemeOutcomeTagsToolTip">
									Outcome Tags ({{t.tags.length}})
									<i class="fa fa-fw fa-info-circle"></i>
								</div>
								<div class="mt-1">
									<inline-editor 
										[saveFn]="saveThemeTags(t, tagControls[t.id].value)" 
										[edited]="!tagControls[t.id].value.containsExactly(t.tags)" 
										(cancel)=" tagControls[t.id].value.resetWith(t.tags)"
										#tagsEditor>
										<div role="region" aria-label="Theme Outcome Tags" readonly>
											<div [hidden]="!t.tags.length" style="padding:5px 2px;">
												<span *ngFor="let tag of t.tags">
													<tag [value]="tag"></tag>
												</span>
											</div>
											<em [hidden]="!!t.tags.length" class="text-sm">
												Click or Tap to edit
											</em>
										</div>
										<div editor>
											<tag-picker 
											    [formControl]="tagControls[t.id]" 
												[tagTypes]="availableTagTypes"></tag-picker>
										</div>
									</inline-editor>
								</div>
							</div>
							<div class="mt-3" *ngIf="abbreviatedActivities">
								<div class="mb-3" *ngFor="let pt of publicationTypes">
									<div class="project-label" [matTooltip]="pt.tooltip">
										{{pt.name}}
										<i class="fa fa-fw fa-info-circle"></i>
									</div>
									<div class="mt-1 text-sm">
										<inline-editor 
											[edited]="themePublications[t.id][pt.id] != t.publications[pt.id] || true" 
											[saveFn]="saveThemePublications(t, pt.id, themePublications[t.id][pt.id])" 
											(cancel)="themePublications[t.id][pt.id] = t.publications[pt.id]"
											#pubsEditor>
											<div role="region" aria-label="Theme Publication" readonly>
												<div [innerHtml]="t.publications[pt.id]"></div>
												<em [hidden]="!!t.publications[pt.id]">
													Click or Tap to edit
												</em>
											</div>
											<div editor *ngIf="pubsEditor.state === 'editing'">
												<textboxio 
													[(content)]="themePublications[t.id][pt.id]" 
													#pubsInput></textboxio>
											</div>
										</inline-editor>
									</div>
								</div>
							</div>
							<div class="card mt-3" *ngIf="abbreviatedActivities">
								<div class="card-header text-sm">
									Cooperative Extension Activities Count: {{totalActivityCount(t)}}
								</div>
								<inline-editor 
									[noOuterBorder]="true"
									[saveFn]="saveThemeActivityCounts(t, themeActivityCounts[t.id])" 
									[edited]="!objectEqualsMap(themeActivityCounts[t.id], t.activityCounts)" 
									(cancel)="resetEditableActivityCountsFor(t)">
									<div readonly class="card-body">
										<div class="row align-items-center">
											<div class="col-md-6 text-xs mb-2" *ngFor="let ast of activitySubTypes">
												<div class="media">
													<input class="form-control form-control-sm float-left mr-2 text-center" 
													style="width:50px; display:inline-block; background:transparent; border:0;"
													[value]="t.activityCounts.get(ast.id) || 0"
													readonly disabled>
													<div class="media-body" [matTooltip]="tooltipSvc.getCampusToolTipBySubTypeId(ast.id)">
														{{ast.name}}
														<i class="fa fa-fw fa-info-circle"></i>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div editor class="card-body">
										<div class="row align-items-center">
											<div class="col-md-6 text-xs mb-2" *ngFor="let ast of activitySubTypes">
												<div class="media">
													<input type="number" min="0" step="1"
													class="form-control form-control-sm float-left mr-2 text-center"
													style="width:50px; display:inline-block;"
													[(ngModel)]="themeActivityCounts[t.id][ast.id]">
													<div class="media-body" [matTooltip]="tooltipSvc.getCampusToolTipBySubTypeId(ast.id)">
														{{ast.name}}
														<i class="fa fa-fw fa-info-circle"></i>
													</div>
												</div>
											</div>
										</div>
									</div>
								</inline-editor>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
